export default __webpack_public_path__ + "static/media/Animations_Circle1.ae028498.svg";